import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState
} from 'react';

interface AriaLiveContextInterface {
  allowMessages?: boolean;
  setAllowMessages?: React.Dispatch<React.SetStateAction<boolean>>;
  removedMessage?: string;
  setRemovedMessage?: (message: string | undefined) => void;
  addedMessage?: string;
  setAddedMessage?: (message: string | undefined) => void;
}

export const AriaLiveContext = createContext<AriaLiveContextInterface>({});

export const AriaLiveContextProvider = ({children}: PropsWithChildren) => {

  const [ allowMessages, setAllowMessages ] = useState(true);
  const [ removedMessage, setRemovedMessage ] = useState<string>();
  const [ addedMessage, setAddedMessage ] = useState<string>();

  const handleRemovedMessage = useCallback((message: string | undefined) => {
    if (allowMessages) {
      setRemovedMessage(message);
    }
  }, [allowMessages]);

  const handleAddedMessage = useCallback((message: string | undefined) => {
    if (allowMessages) {
      setAddedMessage(message);
    }
  }, [allowMessages]);

  useEffect(() => {
    if (removedMessage) {
      setTimeout(() => {
        setRemovedMessage(undefined);
      }, 10000)
    };
  }, [removedMessage]);

  useEffect(() => {
    if (addedMessage) {
      setTimeout(() => {
        setAddedMessage(undefined);
      }, 10000)
    };
  }, [addedMessage]);

  const value = useMemo(() => ({
    allowMessages,
    setAllowMessages,
    removedMessage,
    setRemovedMessage: handleRemovedMessage,
    addedMessage,
    setAddedMessage: handleAddedMessage
  }), [
    allowMessages,
    setAllowMessages,
    removedMessage,
    handleRemovedMessage,
    addedMessage,
    handleAddedMessage
  ]);

  return (
    <AriaLiveContext.Provider value={value}>
      {children}
    </AriaLiveContext.Provider>
  );
};
